import React from "react";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";

const ProductTab = () => {
  const { product } = useSelector((state) => state.productDetails);

  if (!product) return null;

  return (
    <section className="producttab-section">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="producttab-content">
              <Tabs
                defaultActiveKey="productdescription"
                id="uncontrolled-tab-example"
              >
                <Tab eventKey="productdescription" title="Product Description">
                  <p>
                    {product.PROD_DESC}
                  </p>
                  
                  {/* <h4>Item Features</h4>
                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam eu dolor imperdiet, scelerisque nibh ac, fermentum
                      ligula.
                    </li>
                    <li>Contar iquam luctus lorem eget elementum euismod.</li>
                    <li>Fusce id justo ac erat suscipit euismod.</li>
                    <li>Aenean consectetur est blandit magna dictum.</li>
                    <li>Vestibulum sit amet nulla eu justo venenatis.</li>
                    <li>Suspendisse id metus rutrum, dictum massa vitae.</li>
                  </ul> */}
                </Tab>
                <Tab eventKey="privacypolicy" title="Privacy Policy">
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which don't
                    look even slightly believable. If you are going to use a
                    passage of Lorem Ipsum, you need to be sure there isn't
                    anything embarrassing hidden in the middle of text. All the
                    Lorem Ipsum generators on the Internet tend to repeat
                    predefined chunks as necessary, making this the first true
                    generator on the Internet. It uses a dictionary of over 200
                    Latin words, combined with a handful of model sentence
                    structures, to generate Lorem Ipsum which.
                  </p>
                  <h4>Item Features</h4>
                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam eu dolor imperdiet, scelerisque nibh ac, fermentum
                      ligula.
                    </li>
                    <li>Contar iquam luctus lorem eget elementum euismod.</li>
                    <li>Fusce id justo ac erat suscipit euismod.</li>
                    <li>Aenean consectetur est blandit magna dictum.</li>
                    <li>Vestibulum sit amet nulla eu justo venenatis.</li>
                    <li>Suspendisse id metus rutrum, dictum massa vitae.</li>
                  </ul>
                </Tab>
                <Tab eventKey="termsandconditions" title="Terms & Conditions">
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which don't
                    look even slightly believable. If you are going to use a
                    passage of Lorem Ipsum, you need to be sure there isn't
                    anything embarrassing hidden in the middle of text. All the
                    Lorem Ipsum generators on the Internet tend to repeat
                    predefined chunks as necessary, making this the first true
                    generator on the Internet. It uses a dictionary of over 200
                    Latin words, combined with a handful of model sentence
                    structures, to generate Lorem Ipsum which.
                  </p>
                  <h4>Item Features</h4>
                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam eu dolor imperdiet, scelerisque nibh ac, fermentum
                      ligula.
                    </li>
                    <li>Contar iquam luctus lorem eget elementum euismod.</li>
                    <li>Fusce id justo ac erat suscipit euismod.</li>
                    <li>Aenean consectetur est blandit magna dictum.</li>
                    <li>Vestibulum sit amet nulla eu justo venenatis.</li>
                    <li>Suspendisse id metus rutrum, dictum massa vitae.</li>
                  </ul>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour, or randomised words which don't
                    look even slightly believable. If you are going to use a
                    passage of Lorem Ipsum, you need to be sure there isn't
                    anything embarrassing hidden in the middle of text. All the
                    Lorem Ipsum generators on the Internet tend to repeat
                    predefined chunks as necessary, making this the first true
                    generator on the Internet. It uses a dictionary of over 200
                    Latin words, combined with a handful of model sentence
                    structures, to generate Lorem Ipsum which.
                  </p>
                  <h4>Item Features</h4>
                  <ul>
                    <li>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </li>
                    <li>
                      Aliquam eu dolor imperdiet, scelerisque nibh ac, fermentum
                      ligula.
                    </li>
                    <li>Contar iquam luctus lorem eget elementum euismod.</li>
                    <li>Fusce id justo ac erat suscipit euismod.</li>
                    <li>Aenean consectetur est blandit magna dictum.</li>
                    <li>Vestibulum sit amet nulla eu justo venenatis.</li>
                    <li>Suspendisse id metus rutrum, dictum massa vitae.</li>
                  </ul>
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ProductTab;
